export default "__VITE_ASSET__BdwuoqNR__"